import { PlanCard } from './components';
import { DataPlaceholder } from './Placeholder';

export function StateAssessments() {
  return (
    <PlanCard
      title="State Assessments"
      subtitle="Academic achievement on state assessments — data not yet connected."
    >
      <DataPlaceholder text="State assessment results (ELA, math, science) will appear here once the state data feed is connected." />
    </PlanCard>
  );
}
